// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid-border[data-v-78cc4ea2] {\n  border: 1px solid #e5e7eb;\n}\n.custom-toolbar[data-v-78cc4ea2] .dx-datagrid-header-panel {\n  min-width: -moz-fit-content;\n  min-width: fit-content;\n  width: 100%;\n  display: flex;\n}\n.custom-toolbar[data-v-78cc4ea2] .dx-toolbar-center:empty {\n  display: flex;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
